<template>
  <basic-container>
    <!--  -->
    <el-form>
      <el-form-item :error="errorMessage">
        <el-input
          type="textarea"
          :autosize="true"
          readonly
          v-model="userNames"
          @focus="showDialog()"
        ></el-input>
      </el-form-item>
    </el-form>

    <!--  -->
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogVisible"
      append-to-body
      @close="closeUserDialog"
      width="60%"
    >
      <template>
        <el-row>
          <el-form inline>
            <el-form-item label="姓名">
              <el-input v-model="realName"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="phone"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchForm">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row gutter="10">
          <el-col span="6">
            <div>
              <el-tabs type="border-card">
                <el-tab-pane label="部门">
                  <el-tree
                    v-loading="treeLoading"
                    :data="departmentTreeList"
                    :props="defaultProps"
                    @node-click="handleDeptNodeClick"
                  ></el-tree>
                </el-tab-pane>
                <el-tab-pane label="班组">
                  <el-tree
                    v-loading="treeLoading"
                    :data="groupTreeList"
                    :props="defaultProps_"
                    @node-click="handleGroupNodeClick"
                  ></el-tree>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
          <el-col>
            <el-transfer v-model="value" :data="data"></el-transfer>
          </el-col>
          <!-- <el-col span="7">
            <div class="pane">
              <div
                item="for-select"
                name="item-for-select"
                style="cursor: pointer; padding: 1rem 1rem"
                @click="selectUserHandler($event)"
                v-for="(item, index) in dataForUserSelect"
                :key="index"
                :label="item.realName"
                :value="item.id"
              >
                {{ item.realName }}
              </div>
               <el-checkbox-group
            v-model="leftChoosenIds"
            size="small"
            @change="groupChange"
          >
            <div
              v-for="item in leftList"
              :key="item.id"
              style="margin-top: 10px"
            >
              <el-checkbox class="checkbox-item" :label="item.id" >{{
                item.realNameAndPhone
              }}</el-checkbox>
            </div>
          </el-checkbox-group>
            </div>
          </el-col>
          <el-col span="4">
            <div style="text-align: center; margin: 20px 0">
              <el-tag type="info" v-if="single"> 只能选择一人 </el-tag>
            </div>
            <div style="text-align: center; margin: 20px 0">
              <el-button
                type="primary"
                @click="moveLeftAction"
                :disabled="moveLeftDisabled"
                >左移</el-button
              >
            </div>
            <div style="text-align: center; margin: 20px 0">
              <el-button
                type="primary"
                @click="moveRightAction"
                :disabled="moveRightDisabled"
                >右移</el-button
              >
            </div>
          </el-col>
          <el-col span="7">
            <div class="pane">
              <div
                item="for-select"
                name="item-for-selected"
                style="cursor: pointer; padding: 1rem 1rem"
                @click="selectedUserHandler($event)"
                v-for="(item, index) in dataSelectedUsers"
                :key="index"
                :label="item.realName"
                :value="item.id"
              >
                {{ item.realName }}
              </div>
            </div>
             <el-checkbox-group
            v-model="leftChoosenIds"
            size="small"
            @change="groupChange"
          >
            <div
              v-for="item in leftList"
              :key="item.id"
              style="margin-top: 10px"
            >
              <el-checkbox class="checkbox-item" :label="item.id" >{{
                item.realNameAndPhone
              }}</el-checkbox>
            </div>
          </el-checkbox-group>
          </el-col> -->
        </el-row>
        <div style="text-align: center; padding-top: 1rem">
          <el-button
            type="primary"
            @click.native="submitSelectedUserList"
            style="margin-right: 1rem"
          >
            提交
          </el-button>
          <el-button @click.native="closeUserEditBox">取消</el-button>
        </div>
      </template>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  treeByProjectDeptId,
  getUserListByDepartmentId,
  getGroupList,
  getPrincipalUserList,
  getMenberUserList,
} from "@/api/crmedical/group/group";
export default {
  props: {
    single: {
      default: false, //是否为单选模式
    },
    projectId: {
      default: "", //项目id
    },
    remainUserListInside: {
      default: [], //选择的人员列表
    },
    required: {
      default: false,
    },
    message: {
      default: "请选择人员",
    },
  },
  data() {
    return {
      value: [],
      data: [],
      //
      rightChoosenIds: [],
      leftChoosenIds: [],
      //
      dialogVisible: false,
      errorMessage: "",
      userNames: "",
      //搜索条件
      realName: "",
      phone: "",
      treeLoading: false,
      moveLeftDisabled: true,
      moveRightDisabled: true,

      tempSelectedItemId: "",
      tempSelectedItemElement: "",

      dataForUserSelect: [],

      dataSelectedUsers: [],

      departmentTreeList: [],

      originUserList: [],

      groupTreeList: [],

      defaultProps: {
        children: "children",
        label: "title",
      },
      defaultProps_: {
        label: "name",
      },
    };
  },
  watch: {
    remainUserListInside: {
      handler(val) {
        if (val) {
          this.dataSelectedUsers = this.deepClone(val);
        } else {
          this.dataSelectedUsers = this.deepClone(val);
        }
      },
      deep: true,
    },
  },
  methods: {
    handleDataChange(newList) {
      let arr = [];
      this.data.forEach((ele) => {
        if (this.value.includes(ele.id)) {
          arr.push(ele);
        }
      });
      newList.forEach((ele) => {
        if (!this.value.includes(ele.id)) {
          arr.push(ele);
        }
      });
      this.data = arr;
      console.log("this.data==>", this.data);
    },
    async showDialog() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
      });
      //加载部门和班组的基础数据
      try {
        this.dataSelectedUsers = this.remainUserListInside
          ? this.deepClone(this.remainUserListInside)
          : [];
        this.data = this.dataSelectedUsers;
        this.value = this.dataSelectedUsers.reduce((acc, cur) => {
          cur.key = cur.id;
          cur.label = cur.realNameAndPhone;
          acc.push(cur.id);
          return acc;
        }, []);
        const resDept = await treeByProjectDeptId({
          projectId: this.projectId,
        });
        this.departmentTreeList = resDept.data;
        const resGroup = await getGroupList({ projectId: this.projectId });
        this.groupTreeList = resGroup.data;
      } catch (err) {
        console.log("error==>", err);
      }
      loading.close();
      this.dialogVisible = true;
    },
    searchForm() {
      this.resetAllItem();
      getUserListByDepartmentId({
        realName: this.realName,
        phone: this.phone,
      }).then((res) => {
        res.data.forEach((ele, index) => {
          ele.realName = ele.realNameAndPhone;
        });
        this.originUserList = this.deepClone(res.data);
        this.dataForUserSelect = this.deepClone(res.data);
        this.initDataForSelect();
      });
    },
    selectedUserHandler(e) {
      this.resetAllItem();
      this.tempSelectedItemId = e.target.attributes.value.value;
      this.changeRightSelectedItemStyle(e);
      this.tempSelectedItemElement = e.target;
      this.moveLeftDisabled = false;
      // if (this.tempSelectedItemId) {
      //   if (this.tempSelectedItemId === e.target.attributes.value.value) {
      //     e.target.style.backgroundColor = "";
      //     e.target.style.color = "";
      //     this.tempSelectedItemId = "";
      //     this.tempSelectedItemElement = "";
      //     this.moveLeftDisabled = true;
      //   } else {
      //     this.tempSelectedItemId = e.target.attributes.value.value;
      //     this.changeRightSelectedItemStyle(e);
      //     this.tempSelectedItemElement = e.target;
      //     this.moveLeftDisabled = false;
      //     this.moveLeftDisabled = this.filterSelectedUsers();
      //   }
      // } else {
      //   this.tempSelectedItemId = e.target.attributes.value.value;
      //   this.changeRightSelectedItemStyle(e);
      //   this.tempSelectedItemElement = e.target;
      //   this.moveLeftDisabled = false;
      //   // this.moveLeftDisabled = this.filterSelectedUsers();
      // }
      // console.log(this.tempSelectedItemId,e.target);
    },
    selectUserHandler(e) {
      // 单选模式
      this.resetAllItem();
      this.changeLeftSelectedItemStyle(e);
      this.tempSelectedItemId = e.target.attributes.value.value;
      this.tempSelectedItemElement = e.target;
      this.moveRightDisabled = false;
      if (this.single == true) {
        this.moveRightDisabled = this.dataSelectedUsers.length > 0;
        return;
      }
    },
    resetAllItem() {
      this.tempSelectedItemId = "";
      this.tempSelectedItemElement = "";
      this.moveRightDisabled = true;
      this.moveLeftDisabled = true;
      document.querySelectorAll('div[item="for-select"]').forEach((ele) => {
        ele.style.backgroundColor = "";
        ele.style.color = "";
      });
    },
    //切换选中项目的颜色
    changeLeftSelectedItemStyle(e) {
      e.target.style.backgroundColor = "#F5F7FA";
      e.target.style.color = "#409eff";
    },
    changeRightSelectedItemStyle(e) {
      document
        .querySelectorAll('div[name="item-for-selected"]')
        .forEach((ele) => {
          ele.style.backgroundColor = "";
          ele.style.color = "";
        });
      e.target.style.backgroundColor = "#F5F7FA";
      e.target.style.color = "#409eff";
    },
    // filterSelectedUsers() {
    //   let filterFlag = true;
    //   this.originUserList.forEach((element, index) => {
    //     if (this.tempSelectedItemId === element.id) {
    //       filterFlag = false;
    //     }
    //   });
    //   return filterFlag;
    // },
    moveRightAction() {
      let self = this;
      this.dataForUserSelect.forEach((ele, index) => {
        // console.log(
        //   self.tempSelectedItemElement.attributes.value.value,
        //   ele.id
        // );
        if (ele.id === self.tempSelectedItemElement.attributes.value.value) {
          this.dataForUserSelect.splice(index, 1);
        }
      });
      console.log(this.dataForUserSelect);
      this.dataSelectedUsers.push({
        id: this.tempSelectedItemElement.attributes.value.value,
        realName: this.tempSelectedItemElement.attributes.label.value,
      });
      this.resetAllItem();
    },
    moveLeftAction() {
      let self = this;
      this.dataSelectedUsers.forEach((ele, index) => {
        // console.log(
        //   self.tempSelectedItemElement.attributes.value.value,
        //   ele.id
        // );
        if (ele.id === self.tempSelectedItemElement.attributes.value.value) {
          this.dataSelectedUsers.splice(index, 1);
        }
      });
      // console.log(this.dataForUserSelect);
      this.dataForUserSelect.push({
        id: this.tempSelectedItemElement.attributes.value.value,
        realName: this.tempSelectedItemElement.attributes.label.value,
      });

      console.log(this.dataForUserSelect);
      this.resetAllItem();
    },
    // transferChangeHandler(a,b,c){
    //     console.log(a,b,c)
    //     console.log(this.dataSelectedUsers)
    // },
    // transferRightChangeHandler(){
    //     console.log(this.dataSelectedUsers)
    // },
    // transferLeftChangeHandler(){
    //     console.log(this.dataSelectedUsers)
    // },
    handleDeptNodeClick(data) {
      // this.treeLoading = true;
      this.resetAllItem();
      let deptId = data.id;
      //

      getUserListByDepartmentId({ deptId }).then((res) => {
        console.log(res);
        // this.dataForUserSelect = Object.assign({}, this.dataForUserSelect, res.data)
        res.data.forEach((ele, index) => {
          ele.realName = ele.realNameAndPhone;
          ele.key = ele.id;
          ele.label = ele.realNameAndPhone;
        });
        this.originUserList = this.deepClone(res.data);
        this.dataForUserSelect = this.deepClone(res.data);
        this.handleDataChange(this.originUserList);
        console.log(this.dataForUserSelect);
        this.initDataForSelect();
        this.treeLoading = false;
      });
      console.log(data);
    },
    handleGroupNodeClick(data) {
      this.treeLoading = true;
      this.resetAllItem();
      let groupId = data.id;
      //班组成员
      getMenberUserList({ groupId }).then((res) => {
        console.log(res);
        res.data.forEach((ele, index) => {
          ele.realName = ele.realNameAndPhone;
        });
        this.originUserList = this.deepClone(res.data);
        this.dataForUserSelect = this.deepClone(res.data);
        console.log(this.dataForUserSelect);
        this.initDataForSelect();
        this.treeLoading = false;
      });
      console.log(data);
      //班组负责人
      // getPrincipalUserList({ groupId }).then((res) => {
      //   console.log(res);
      //   res.data.forEach((ele, index) => {
      //     ele.realName = ele.realNameAndPhone;
      //   });
      //   this.originUserList = this.deepClone(res.data);
      //   this.dataForUserSelect = this.deepClone(res.data);
      //   console.log(this.dataForUserSelect);
      //   this.initDataForSelect();
      //   this.treeLoading = false;
      // });
      // console.log(data);
    },

    initDataForSelect() {
      console.log("nitDataForSelect");
      let arrListSelected = this.deepClone(this.dataSelectedUsers);
      let arrListForSelect = this.deepClone(this.dataForUserSelect);
      if (arrListSelected.length > 0) {
        arrListSelected.forEach((ele, i) => {
          arrListForSelect.forEach((element, index) => {
            if (element.id === ele.id) {
              arrListForSelect.splice(index, 1);
            }
          });
        });
      }

      this.dataForUserSelect = arrListForSelect;
    },
    closeUserEditBox() {
      this.dialogVisible = false;
      this.$emit("closeAction");
    },
    submitSelectedUserList() {
      // let idList = [];
      // let nameList = [];
      // this.dataSelectedUsers.forEach((e, i) => {
      //   idList.push(e.id);
      //   nameList.push(e.realName);
      // });
      // if (idList.length > 0) {
      //   idListString = idList.join(",");
      //   this.userNames = nameList.join("，");
      // }

      let result = [];
      this.data.forEach((ele) => {
        if (this.value.includes(ele.id)) {
          result.push(ele);
        }
      });
      this.userNames = this.dataSelectedUsers.reduce((acc, cur, idx, src) => {
        acc += cur.realName;
        if (idx < src.length - 1) {
          acc += "，";
        }
        return acc;
      }, "");
      this.userNames = result.reduce((acc, cur, idx, src) => {
        acc += cur.realName;
        if (idx < src.length - 1) {
          acc += "，";
        }
        return acc;
      }, "");
      this.$emit("update:remainUserListInside", this.dataSelectedUsers);
      // this.$emit("editAction", {
      //   idListString: idListString,
      //   nameListString: nameListString,
      //   dataSelectedUsers: this.dataSelectedUsers,
      // });
      if (this.required == true && this.dataSelectedUsers.length == 0) {
        this.errorMessage = this.message || "请选择人员";
      }
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.pane {
  height: 400px;
  padding-left: 10px;
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  text-align: left;
  overflow: scroll;
}
::v-deep .el-dialog {
  margin: 2vh auto 2vh !important;
}
::v-deep .el-tabs__content {
  height: 360px;
  overflow: scroll;
}
</style>>
